import api from './index'
import { Toast } from 'dingtalk-design-mobile'

const doFetch = (
  method, url, params, config
) => new Promise(resolve => {
  if (config && config.loading) {
    Toast.loading({
      content: '加载中...',
      showType: 'normal',
      duration: 0
    })
  }
  api[method](url, params).then(d => {
    setTimeout(() => {
      Toast.hide()
    }, 1000)
    if (d && d.success) {
      resolve([true, d.result, d])
    } else {
      throw d
    }
  }).catch(e => {
    Toast.fail({
      content: e.errorMsg || '请求失败',
      duration: 2
    })
    resolve([false, e])
  })
})

export default {
  get: (...p) => doFetch('get', ...p),
  post: (...p) => doFetch('post', ...p),
}
